module.exports = __webpack_public_path__ + "img/284.a77be687.jpg";